import { getRoasBaseline } from './dr-utils'

export const colorRules = [
  {
    day: 'day0',
    threshold: 60,
    lowThreshold: 40,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day1',
    threshold: 70,
    lowThreshold: 50,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day2',
    threshold: 70,
    lowThreshold: 50,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day3',
    threshold: 70,
    lowThreshold: 50,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day4',
    threshold: 80,
    lowThreshold: 60,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day5',
    threshold: 85,
    lowThreshold: 65,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day6',
    threshold: 90,
    lowThreshold: 70,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day7',
    threshold: 95,
    lowThreshold: 75,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day8',
    threshold: 100,
    lowThreshold: 80,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day9',
    threshold: 100,
    lowThreshold: 80,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  {
    day: 'day10',
    threshold: 100,
    lowThreshold: 80,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
  // Default rule for day 11+
  {
    day: 'default',
    threshold: 100,
    lowThreshold: 80,
    belowColor: 'text-red-600',
    lowColor: 'text-foreground',
    aboveColor: 'text-green-600',
  },
]

export const getColorByValue = (value, cost, dayIndex, day0RoasLine, date) => {
  if (!value || !cost) return ''

  const ratio = (value / cost) * 100 // Convert to percentage
  const rule =
    colorRules.find((r) => r.day === `day${dayIndex}`) ||
    colorRules.find((r) => r.day === 'default')

  // 如果 day0RoasLine 是对象格式（新的格式），使用 getRoasBaseline 获取对应的值
  let baseline = null
  if (day0RoasLine && typeof day0RoasLine === 'object' && date) {
    baseline = getRoasBaseline(day0RoasLine, dayIndex, date)
  } else if (typeof day0RoasLine === 'number') {
    // 兼容旧格式：直接使用数字
    baseline = day0RoasLine
  }

  // 对于所有配置了 baseline 的标准日，使用 baseline 进行比较
  if (baseline !== null) {
    if (ratio <= baseline * 100) return rule.belowColor
    if (ratio >= baseline * 100) return rule.aboveColor
  }

  // 其他情况使用原有的规则
  if (ratio <= rule.lowThreshold) return rule.belowColor
  if (ratio >= rule.threshold) return rule.aboveColor
  return rule.lowColor
}
